import { SET_AUTHENTICATED, SET_UNAUTHENTICATED, RESET_REDUX, SET_LOGOUT_IN_PROGRESS } from "../../actions/actionTypes";

const initialState = {
  isAuthenticated: false,
  logoutInProgress: false
};

const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_AUTHENTICATED: {
      return {
        ...state,
        isAuthenticated: true,
        logoutInProgress: false,
      }
    }

    case SET_UNAUTHENTICATED: {
      return {
        ...state,
        isAuthenticated: false
      }
    }

    case SET_LOGOUT_IN_PROGRESS: {
      return {
        ...state,
        logoutInProgress: true,
      }
    }

    case RESET_REDUX: {
      return {
        ...initialState
      }
    }

    default: {
      return state;
    }
  }
};

export default authReducer;
